import React, { Suspense, useEffect } from 'react';
import PortalLoader from './components/PortalLoader';
import CartCountBadge from './components/portals/CartCountBadge';
import MDiForm from './components/portals/MDiForm';
import LoadingIcon from './components/Loading';

type AppProps = {
  config: any,
}

export const App: React.FC<AppProps> = ({ config }) => {

  return (
    <>
      <Suspense fallback={<LoadingIcon />}>
        <PortalLoader
          dataAttr={'data-app-layer-portal="form-portal"'}
          Component={MDiForm}
        />
      </Suspense>
      <Suspense fallback={<LoadingIcon />}>
        <PortalLoader
          dataAttr={'data-app-layer-portal="cart-count-badge"'}
          Component={CartCountBadge}
        />
      </Suspense>
    </>
  )
}

export default App;
